import { render, staticRenderFns } from "./OrderStep.vue?vue&type=template&id=670a07aa&scoped=true&"
import script from "./OrderStep.vue?vue&type=script&lang=js&"
export * from "./OrderStep.vue?vue&type=script&lang=js&"
import style0 from "./OrderStep.vue?vue&type=style&index=0&id=670a07aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670a07aa",
  null
  
)

export default component.exports